import { TextField } from '@material-ui/core';
import Text from 'components/base/Text';
import { Padding } from 'components/base/layout-components';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

const TextFieldWrapper = styled(Padding)`
  height: 2rem;
  border-radius: 4px;
  margin-top: 0.7rem;
  border: ${({ borderColor }) =>
    `1px solid ${
      borderColor ? getColor(borderColor) : getColor('botticelli')
    }`};
`;

export const getInputField = ({
  name,
  paddingTop = '',
  value,
  onChange,
  validationMessage = ''
}) => {
  return (
    <Padding t={paddingTop} b='normal'>
      <Text color='shuttleGray'>{name}</Text>
      <TextFieldWrapper
        padding='x-small'
        borderColor={validationMessage ? 'torchRed' : null}
      >
        <TextField
          value={value}
          onChange={onChange}
          size='small'
          InputProps={{
            inputProps: {
              style: {
                fontSize: 12
              }
            },
            disableUnderline: true
          }}
          data-cy={`invite-user-${name}-input`}
        />
      </TextFieldWrapper>
      <Text color='torchRed' pt='0.2rem'>
        {validationMessage}
      </Text>
    </Padding>
  );
};

// eslint-disable-next-line jsdoc/require-jsdoc
export const handleInviteUserError = e => {
  try {
    const errorDescription = JSON.parse(e?.response?.data?.description);
    if (Array.isArray(errorDescription) && errorDescription[0]?.msg) {
      return errorDescription[0].msg;
    }
    return 'An error has occurred, please try again.';
  } catch (error) {
    return 'An error has occurred, please try again.';
  }
};
